import React, { useState, useRef, useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { getProtectedResource, updatePriceHistory } from "../utils/api";

import PriceHistoryModal from "./PriceHistoryModal";
import { Today } from "@mui/icons-material";

const Propertybanner = ({
    propertyId,
    Profile,
    imageUrl1,
    imageUrl2,
    priceType,
    price,
    OldPrice,
    size,
    Status,
    pricePerMeter,
    address,
    description,
    Type,
    Bathrooms,
    Bedrooms,
    Sittingrooms,
    addedDate,
    viewLink,
    isActive,
    FloorPlans,
    ScotLISLink,
    PriceHistory,
    onClick // Use only onClick here
}) => {



    const [hoverPosition, setHoverPosition] = useState(null);
    const [hoverPosition2, setHoverPosition2] = useState(null);
    const [currentPlanIndex, setCurrentPlanIndex] = useState(0);
    const [currentImageIndex, setcurrentImageIndex] = useState(0);
    const [isHovering, setIsHovering] = useState(false);
    const [isHoveringimages, setisHoveringimages] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const containerRef = useRef(null); // Reference to the floor plan container
    const containerRef2 = useRef(null); // 


    const { getAccessTokenSilently } = useAuth0();

    let imgSrc;
    const bedSrc = require('../Assets/double-bed.png');
    const toiletSrc = require('../Assets/toilet.png')
    const sofaSrc = require('../Assets/seater-sofa.png')
    const homesave = require('../Assets/home.png')
    const pricehistory = require('../Assets/profits.png')
    const missingFloorPlan = require('../Assets/blueprint.png')





    const handleMouseEnter = () => {


        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
        setHoverPosition(null); // Clear hover position when the mouse leaves
    };

    const handleMouseMove = (e) => {
        if (isHovering) {
            setHoverPosition({ x: e.clientX + 10, y: e.clientY + 10 });
        }
    };

    const handleMouseEnterImages = () => {
        setisHoveringimages(true);
    };

    const handleMouseLeaveImages = () => {
        setisHoveringimages(false);
        setHoverPosition2(null); // Clear hover position when the mouse leaves
    };

    const handleMouseMoveImages = (e) => {
        if (setisHoveringimages) {
            setHoverPosition2({ x: e.clientX + 10, y: e.clientY + 10 });
        }
    };



    const handleWheel = (e) => {
        if (!FloorPlans || FloorPlans.length <= 1) return; // No scrolling if only one plan

        e.preventDefault(); // Prevent default scroll behavior

        if (e.deltaY > 0) {
            // Scroll down
            setCurrentPlanIndex((prevIndex) =>
                prevIndex === FloorPlans.length - 1 ? 0 : prevIndex + 1
            );
        } else {
            // Scroll up
            setCurrentPlanIndex((prevIndex) =>
                prevIndex === 0 ? FloorPlans.length - 1 : prevIndex - 1
            );
        }
    };

    const handleWheelimages = (e) => {
        if (!imageUrl2 || imageUrl2.length <= 1) return; // No scrolling if only one plan

        e.preventDefault(); // Prevent default scroll behavior

        if (e.deltaY > 0) {
            // Scroll down
            setcurrentImageIndex((prevIndex) =>
                prevIndex === imageUrl2.length - 1 ? 0 : prevIndex + 1
            );
        } else {
            // Scroll up
            setcurrentImageIndex((prevIndex) =>
                prevIndex === 0 ? imageUrl2.length - 1 : prevIndex - 1
            );
        }
    };

    useEffect(() => {
        const element = containerRef.current;

        if (isHovering && element) {
            // Attach non-passive event listener
            element.addEventListener("wheel", handleWheel, { passive: false });

            return () => {
                element.removeEventListener("wheel", handleWheel, { passive: false });
            };
        }
    }, [isHovering]); // Re-run when `isHovering` changes

    useEffect(() => {
        const element2 = containerRef2.current;


        if (isHoveringimages && element2) {

            // Attach non-passive event listener
            element2.addEventListener("wheel", handleWheelimages, { passive: false });

            return () => {
                element2.removeEventListener("wheel", handleWheelimages, { passive: false });
            };
        }


    }, [isHoveringimages]); // Re-run when `isHovering` changes



    const currentPlanImage =
        FloorPlans[currentPlanIndex] === "No Floor Plan"
            ? missingFloorPlan
            : FloorPlans[currentPlanIndex];



    switch (Type) {
        case 'flat':
            imgSrc = require('../Assets/apartments.png');
            break;
        case 'semi-detached':
            imgSrc = require('../Assets/townhouse.png'); // Update path accordingly
            break;
        case 'terrace':
            imgSrc = require('../Assets/terrace.png'); // Update path accordingly
            break;
        case 'house':
            imgSrc = require('../Assets/house1.png');
            break;
        default:
            imgSrc = 'path/to/default-image.png'; // Fallback image path
    }

    const getStatusClassName = (statusType) => {
        if (statusType === 'None') {
            return ''; // No class needed for 'None'
        } else if (statusType === 'Under offer') {
            return 'UnderOffer'; // Assuming 'underOffer' is the class for items under offer
        } else if (statusType.includes('Closing')) {
            return 'Closing'; // For any status that includes "Closing"
        } else if (statusType.includes('Sold')) {
            return 'Sold'; // For any status that includes "Sold"
        } else if (statusType.includes('Withdrawn')) {
            return 'Sold'; // For any status that includes "Sold"
        } else {
            return 'defaultClass'; // Fallback class if needed
        }
    }

    const handleSave = async (event) => {

        try {
            const accessToken = await getAccessTokenSilently();
            const { data, error } = await getProtectedResource(accessToken, propertyId, Profile);

            console.log("Property saved successfully", data);
        } catch (error) {
            console.error("Error saving property", error);
        }
    };


    const formatPrice = (price) => {
        if (price == null) return ''; // handle null/undefined gracefully

        const number =
            typeof price === 'number'
                ? price
                : parseFloat(String(price).replace(/[^0-9.-]+/g, ''));

        return new Intl.NumberFormat('en-UK', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(number);
    };

    const formatUTCDate = (utcDateString) => {
        // Parse the UTC date-time string to a Date object
        const date = new Date(utcDateString);

        // Extract year, month, and day
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() returns month index (0-11), so add 1
        const day = String(date.getUTCDate()).padStart(2, '0');

        // Format to YYYY-MM-DD
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    const hasDate = OldPrice && OldPrice[0] && OldPrice[0].date;

    const normalizeHistory = (raw) => {
        if (!Array.isArray(raw)) return [];
        return raw
            .map(h => {
                const price = Number(h?.Price);
                const date = h?.Date ? new Date(h.Date) : null;
                if (!date || Number.isNaN(price)) return null;
                return { date, price };
            })
            .filter(Boolean)
            .sort((a, b) => a.date - b.date);
    };

    const formatDate = (d) => d.toISOString().slice(0, 10);

    const PriceSparkline = ({ points, width = 180, height = 44 }) => {
        if (!points.length) return null;

        const values = points.map(p => p.price);
        const min = Math.min(...values);
        const max = Math.max(...values);
        const span = max - min || 1;

        const pad = 3;
        const stepX = (width - pad * 2) / Math.max(points.length - 1, 1);

        const coords = points.map((p, i) => {
            const x = pad + i * stepX;
            const y = pad + (height - pad * 2) * (1 - (p.price - min) / span);
            return `${x},${y}`;
        }).join(" ");

        return (
            <svg width={width} height={height} style={{ display: "block" }}>
                <polyline points={coords} fill="none" stroke="currentColor" strokeWidth="2" />
            </svg>
        );
    };

    const history = normalizeHistory(PriceHistory);

    const first = history[0]?.price;
    const last = history[history.length - 1]?.price;
    const delta = (first != null && last != null) ? (last - first) : null;
    const deltaPct = (delta != null && first) ? (delta / first) * 100 : null;
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
    const addedMs = new Date(addedDate).getTime();
    const nowMs = Date.now();

    const isWithin30Days = (nowMs - addedMs) <= 2 * MS_PER_DAY;


    // Directly use onClick provided by parent component for click handler
    return (
        <div onClick={onClick} style={{ cursor: "pointer" }} className={isActive ? "propertybanner active" : "propertybanner"}>
            <div className="leftsplit">
                <div className="lefttopsplit">
                    <div className={`PropertyStatus${getStatusClassName(Status.Type)}`}>
                        {Status.Type === "None" ? "" : Status.Type}
                    </div>
                    <div
                        ref={containerRef2}
                        className="ImageHover"
                        onMouseEnter={handleMouseEnterImages}
                        onMouseMove={handleMouseMoveImages}
                        onMouseLeave={handleMouseLeaveImages}
                    >
                        <img
                            className="firstimage"
                            alt="house 1"
                            src={imageUrl2[0] + "?width=149&quality=50&autorotate=true"}
                        />
                    </div>

                    {imageUrl2?.[1] && <img className="secondimage" alt="House 2" src={imageUrl2[1] + "?width=149&quality=50&autorotate=true&quot"} />}
                    <div
                        ref={containerRef}
                        className="FloorPlan"
                        onMouseEnter={handleMouseEnter}
                        onMouseMove={handleMouseMove}
                        onMouseLeave={handleMouseLeave}

                    >
                        <img
                            alt={
                                FloorPlans[currentPlanIndex] === "No Floor Plan"
                                    ? "Missing Floor Plan"
                                    : "Floor Plan"
                            }
                            src={currentPlanImage}
                        />
                    </div>

                </div>
                {hasDate ? (
                    <div className="leftbottomsplit">

                        <h4>{priceType} <s>{formatPrice(OldPrice[0]?.Value)}</s> {formatPrice(price)}</h4>
                        <h4>Reduced on {formatUTCDate(OldPrice[0]?.date)}</h4>
                    </div>
                ) : (
                    <div className="leftbottomsplit">

                        <h3>{priceType} {formatPrice(price)}</h3>
                    </div>
                )}
            </div>
            <div
                className="Rightsplit"
                style={{ backgroundColor: isWithin30Days ? "#deecfdff" : "" }}
            >
                <div className="Righttopsplit">
                    <div className="Righttopleft">
                        <h4 className="min-widthclass">{address}</h4>
                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                            <img className="PropertyClass" src={imgSrc} alt={Type}></img>
                            <img className="roomnumbers" src={bedSrc} alt={Bedrooms}></img>
                            <p className="spacer">{Bedrooms}</p>
                            <img className="roomnumbers" src={toiletSrc} alt={Bathrooms}></img>
                            <p className="spacer">{Bathrooms}</p>
                            <img className="roomnumbers" src={sofaSrc} alt={Sittingrooms}></img>
                            <p className="spacer">{Sittingrooms}</p>
                        </div>
                    </div>

                    <div className="pricehistorytable" style={{ fontSize: "13px", minWidth: "220px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                            <div>
                                <div style={{ fontWeight: 700 }}>Price history</div>
                            </div>
                        </div>
                        {history.length > 0 && (
                            <div style={{ maxHeight: 140, overflow: "auto" }}>
                                {history.slice().reverse().map((h, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",


                                        }}
                                    >
                                        <div style={{ opacity: 0.8 }}>{formatDate(h.date)}</div>
                                        <div style={{ fontWeight: 700 }}>{formatPrice(h.price)}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="RighttopRight">

                        <img width={36} src={homesave} alt="Save" onClick={handleSave}></img>
                        <a href={ScotLISLink} target="_blank" rel="noopener noreferrer"><img width={36} src={pricehistory} alt="Save"></img></a>


                    </div>


                </div>
                <div className="RightbottomSplit" style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
                    <div style={{ display: "flex" }}>
                        <p className="addon">Added on {addedDate}</p>


                        <p className="sqm2">{size} - {pricePerMeter}</p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <button
                            onClick={(e) => { e.stopPropagation(); setShowHistoryModal(true); }}
                            style={{ marginLeft: 8 }}
                            title="Edit price history"
                        >
                            ✎
                        </button>
                        <a style={{ fontWeight: "700", textDecorationLine: "none" }} href={viewLink} target="_blank" rel="noopener noreferrer">View</a>
                    </div>
                </div>

            </div>

            <PriceHistoryModal
                open={showHistoryModal}
                initialHistory={PriceHistory}
                onClose={() => setShowHistoryModal(false)}
                onSave={async (newHistory) => {
                    const token = await getAccessTokenSilently();
                    await updatePriceHistory(token, propertyId, newHistory); // function below
                }}
                title={`Edit price history — ${address}`}
            />

            {hoverPosition && (
                <div
                    style={{
                        position: "fixed",
                        top: "5vh",
                        left: hoverPosition?.x || 0,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        zIndex: 1000,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <p className="FloorPlanNumber">{currentPlanIndex + 1}/{FloorPlans.length}</p>
                    <img
                        className="TooltipFloorPlan"
                        alt={
                            FloorPlans[currentPlanIndex] === "No Floor Plan"
                                ? "Missing Floor Plan"
                                : "Floor Plan"
                        }
                        src={currentPlanImage + "?width=1080&quality=80&autorotate=true&quote"}
                    />
                </div>
            )}

            {hoverPosition2 && (
                <div
                    style={{
                        position: "fixed",
                        top: "5vh",
                        left: hoverPosition2?.x || 0,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        zIndex: 1000,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",

                    }}
                >
                    <p className="FloorPlanNumber">
                        {currentImageIndex + 1}/{imageUrl2.length}
                    </p>
                    <img style={{ maxWidth: "50vw" }}
                        className="TooltipImage"
                        alt="Hovered Image"
                        src={imageUrl2[currentImageIndex] + "?width=1080&quality=80&autorotate=true&quote" || imageUrl1 + "?width=1080&quality=80&autorotate=true&quote"}
                    />
                </div>
            )}

        </div>
    );
};

export default Propertybanner;
